import api from './api';

export interface Customer {
  id: number;
  code: string;
  name: string;
  phone?: string;
  email?: string;
  address?: string;
  tax_code?: string;
  contact_person?: string;
  notes?: string;
  status: 'active' | 'inactive';
  created_at: string;
  updated_at: string;
  total_orders?: number;
  total_amount?: number;
  loyalty_percentage?: number;
}

export interface CustomerDetail {
  customer: Customer;
  orders: any[];
}

export interface CustomerStats {
  totalCustomers: number;
  activeCustomers: number;
  inactiveCustomers: number;
  totalValue: number;
}

export interface PortalTokenInfo {
  hasToken: boolean;
  token?: string;
  url?: string;
  is_active?: number;
  expires_at?: string | null;
  created_at?: string;
  last_accessed_at?: string | null;
}

export const customerService = {
  // Lấy danh sách khách hàng
  getCustomers: async (params?: any) => {
    const response = await api.get('/api/customers', { params });
    return response.data;
  },

  // Lấy chi tiết khách hàng
  getCustomerDetail: async (id: number) => {
    const response = await api.get(`/api/customers/${id}`);
    return response.data.data;
  },

  // Tạo khách hàng mới
  createCustomer: async (data: any) => {
    const response = await api.post('/api/customers', data);
    return response.data;
  },

  // Cập nhật khách hàng
  updateCustomer: async (id: number, data: any) => {
    const response = await api.put(`/api/customers/${id}`, data);
    return response.data;
  },

  // Xóa khách hàng
  deleteCustomer: async (id: number) => {
    const response = await api.delete(`/api/customers/${id}`);
    return response.data;
  },

  // Lấy thống kê tổng hợp khách hàng
  getCustomerStats: async (params?: any): Promise<CustomerStats> => {
    const response = await api.get('/api/customers/stats', { params });
    return response.data.data;
  },

  // Lấy danh sách khách hàng cho select
  getCustomersForSelect: async (params?: any) => {
    const response = await api.get('/api/customers/select/list', { params });
    return response.data.data;
  },

  // Portal token APIs
  getPortalTokenInfo: async (customerId: number): Promise<PortalTokenInfo> => {
    const response = await api.get(`/api/customers/${customerId}/portal-token`);
    return response.data;
  },

  createPortalToken: async (customerId: number, expiresAt?: string): Promise<PortalTokenInfo> => {
    const response = await api.post(`/api/customers/${customerId}/portal-token`, expiresAt ? { expires_at: expiresAt } : {});
    return {
      hasToken: true,
      token: response.data.token,
      url: response.data.url,
    };
  },

  resetPortalToken: async (customerId: number, expiresAt?: string): Promise<PortalTokenInfo> => {
    const response = await api.put(`/api/customers/${customerId}/portal-token/reset`, expiresAt ? { expires_at: expiresAt } : {});
    return {
      hasToken: true,
      token: response.data.token,
      url: response.data.url,
    };
  },

  disablePortalToken: async (customerId: number) => {
    await api.delete(`/api/customers/${customerId}/portal-token`);
  }
}; 